export default "__VITE_ASSET__BdBzf_OT__"